import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { Postcodes, EmailDomains, Codes } from 'bff/models/info';
import { LinkCategory } from 'constants/enums/linkCategory.enum';
import { Links } from 'bff/models/link';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { PetDoc } from 'bff/models/link/petDoc';

/**
 * @description 取得 初始化資料
*/
export const fetchPetInitInfo = async (insTypeId:string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const result = await Promise.all([
    apiService.fetchPostcode(baseReq, reqConfig),
    apiService.fetchEmailDN(baseReq, reqConfig),
    apiService.fetchLinkByCategory(baseReq, reqConfig, LinkCategory.PetDoc), // todo temp
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI),
    apiService.fetchInscat(baseReq, reqConfig)
  ]).then(([postcodesRes, emailDomainsRes, docLinksRes, UICodeRes, inscatBaseRes]) => {
    const postcodesBaseRes: BaseRes<Postcodes> = { ...postcodesRes };
    const emailDomainsBaseRes: BaseRes<EmailDomains> = { ...emailDomainsRes };
    const docLinksBaseRes: BaseRes<Links<PetDoc>> = { ...docLinksRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };
    const inscatRes = inscatBaseRes.TRANRS.INSURANCE_CATEGORY.find((inscat: any) => inscat.INS_TYPE_ID === insTypeId);

    const res = {
      postcodes: commonService.arrayTypeReturn(postcodesBaseRes.TRANRS.POSTCODE),
      emailDomains: commonService.arrayTypeReturn(emailDomainsBaseRes.TRANRS.EMAILDN),
      docLinks: commonService.arrayTypeReturn(docLinksBaseRes.TRANRS.LINKS?.PETDOC),
      UICode: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES),
      inscatRes
    };

    return res;
  });

  return result;
};
